import useSEO from "@/lib/useSEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { PEOPLE } from "@/data/site";

const Continuity = () => {
  const stages = [
    { year: "1990", label: "Foundation", body: "CA Arun Kumar Gupta establishes the firm in Kanpur." },
    { year: "Today", label: "Established Practice", body: "A boutique practice across audit, tax, accounting and advisory." },
    { year: "Forward", label: "Evolving Perspective", body: "A next generation extending the firm into broader finance." },
  ];
  return (
    <section className="py-14 lg:py-20" style={{ background: "#17263D" }} data-testid="people-continuity">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <Reveal>
          <div className="overline">Continuity</div>
          <h2 className="font-serif text-ivory text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 max-w-2xl leading-[1.1]">
            One practice, carried forward.
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mt-14">
          {stages.map((s, i) => (
            <Reveal key={s.year} delay={i * 0.1}>
              <div className="border-t pt-6" style={{ borderColor: "rgba(179,154,98,0.5)" }}>
                <div className="font-serif text-brass text-5xl lg:text-6xl leading-none">{s.year}</div>
                <div className="overline mt-4">{s.label}</div>
                <p className="mt-3 text-base leading-relaxed text-ivory/70">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

const People = () => {
  useSEO({
    title: "Our People",
    description:
      "Meet CA Arun Kumar Gupta, founder and partner, and CA Ankur Gupta, partner, at Arun Gupta & Co. Chartered Accountants in Kanpur.",
    path: "/our-people",
  });

  return (
    <>
      <PageHero
        eyebrow="Our People"
        titleLines={["Experience and", "perspective behind", "the practice."]}
        intro="A boutique firm led by the people who do the work — with the continuity of a founder's experience and the perspective of a new generation."
        testId="people-hero"
      />

      {PEOPLE.map((p, idx) => (
        <section key={p.id} className={`py-14 lg:py-20 ${idx % 2 === 1 ? "" : "border-t border-border-subtle"}`} style={idx % 2 === 1 ? { background: "#EFEBE1" } : undefined} data-testid={`people-profile-${p.id}`}>
          <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
            <div className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start ${idx % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
              <div className="lg:col-span-5 lg:[direction:ltr]">
                <Reveal className="relative overflow-hidden" style={{ aspectRatio: "4 / 5", background: "#E7E2D8" }}>
                  <img src={p.image} alt={`${p.name}, ${p.role}`} className="img-cover" style={{ objectPosition: p.objectPosition }} loading="lazy" />
                </Reveal>
              </div>
              <div className="lg:col-span-6 lg:col-start-7 lg:[direction:ltr]">
                <Reveal>
                  <div className="overline">{p.role}</div>
                  <h2 className="font-serif text-navy text-4xl lg:text-5xl tracking-tight mt-4 leading-[1.05]">{p.name}</h2>
                  <div className="h-px w-20 bg-brass/60 mt-6" />
                  <div className="mt-7 space-y-4 max-w-xl">
                    {p.paragraphs.map((para, i) => (
                      <p key={i} className="text-base lg:text-lg leading-[1.7] text-charcoal/80">
                        {para}
                      </p>
                    ))}
                  </div>
                </Reveal>
              </div>
            </div>
          </div>
        </section>
      ))}

      <Continuity />
    </>
  );
};

export default People;
